export default "__VITE_ASSET__CCOrhgR___"